export default {
  type: 'list',
  label: 'Lista',
  shape: 'square'
}